import { api } from "./api";

/**
 * "View vehicle details" from a renter's confirmation/booking view. Two auth
 * contexts hit the same customer-safe backend projection
 * (`vehicles/customer_safe.py`) via two different routes: the public
 * confirmation-token page (no login) and the authenticated customer portal.
 */
export async function getConfirmationTokenVehicle(token) {
  const r = await api.get(`/public/confirm/${token}/vehicle`);
  return r.data;
}

export async function getPortalBookingVehicle(bookingId) {
  const r = await api.get(`/customer/bookings/${bookingId}/vehicle`);
  return r.data;
}
